import React, { Component } from 'react';
import axios from 'axios';
import Face from '../../img/face.png';
import { ROOT_URL, TOKEN } from '../../config';
import { SocialMedia2 } from '../reusable/social-media';
import MetaTags from 'react-meta-tags';

export default class SinglePost extends Component {
  state = {
    data: '',
    loading: true,
  }

  componentDidMount() {
    axios.get(`${ROOT_URL}/cockpit-master/api/collections/get/Blog?token=${TOKEN}`, {
    method: 'GET',
    authorization: 'basic',
    headers: { 'Content-Type': 'application/json', /*'Access-Control-Allow-Origin': '*'*/ },
  })
    .then(res => this.setState({
      data: res.data,
      loading: false
    }))
  }

  renderImages = () => {
    const { entries } = this.state.data;
    return(
      entries.map((entrie, i) => {
        if(this.props.match.params.id == entrie.id) {
          if(entrie.media[0]) {
            return(
              entrie.media.map((media, i) => {
                return(
                  <div key={i} className="column col-4 nop">
                    <img src={ROOT_URL + media.path}/>
                  </div>
                );
              })
            );
          }
          if(entrie.video) {
            return(
              <div key={i} className="column col-6 nop">
                <video className="video" controls src={ROOT_URL + '/cockpit-master/storage/uploads' + entrie.video.path}/>
              </div>
            );
          } else {
            return;
          }
        }
      })
    );
  }

  renderSinglePost = () => {
    const { entries } = this.state.data;
    let url = ROOT_URL + this.props.location.pathname;
    const appId = "2052553054966733";
    return (
      entries.map((entrie, i) => {
        if(this.props.match.params.id == entrie.id) {
          return (
            <div key={entrie.id} className="item card">
              <MetaTags id={entrie.id}>
                <meta property="og:image" content={ROOT_URL + entrie.image.path}/>
                <meta property="og:description" content={entrie.beschreibung}/>
                <meta property="og:title" content={entrie.titel}/>
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:type" content="article"/>
              </MetaTags>
              <div className="overflow-hidden-2 ">
                <img alt-text="" src={ROOT_URL + entrie.image.path}/>
              </div>
              <h2 className="effect container ">{entrie.titel}</h2>
              <div className="row col-12">
                <div className="column col-10 nop">
                  <p className="effect">{entrie.beschreibung}</p>
                </div>
                <div className="column col-2">
                  <div>
                    <SocialMedia2 id={'?' + entrie.id} title={entrie.titel} media={ROOT_URL + entrie.image.path} description={entrie.beschreibung}/>
                  </div>
                </div>
                <div className="row col-12">
                  {this.renderImages()}
                </div>
              </div>
            </div>
          );
        }
      })
    );
  }

  render() {
    if(this.state.loading) {
      return(<div>...loading</div>);
    } else {
      return (
        <div className="container">
          {this.renderSinglePost()}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/singlePost.js